/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData(value) {
    if (!('Code' in value) || value['Code'] === undefined)
        return false;
    if (!('CodeVerifier' in value) || value['CodeVerifier'] === undefined)
        return false;
    if (!('DeviceId' in value) || value['DeviceId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Code': json['Code'],
        'CodeVerifier': json['CodeVerifier'],
        'DeviceId': json['DeviceId'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Code': value['Code'],
        'CodeVerifier': value['CodeVerifier'],
        'DeviceId': value['DeviceId'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData.js.map